import React, { useContext } from "react";
import { SettingsContext } from "./SettingsContext.tsx";
import { SelectButton } from "primereact/selectbutton";
import { RadioButton } from "primereact/radiobutton";
import { RATIO_MAX_VALUE_OPTIONS, RatioQuestionOptions } from "../Constants.ts";
import { withLabels } from "../Labels.ts";
import { useTranslation } from "../../Shared/i18n/useTranslation.ts";

/**
 * The two ratio dials (ADR 0035 §2).
 *
 * Equivalent Ratios and Proportions are the same mathematics in two notations
 * and both are offered on purpose - a student who can do 2 : 3 = 8 : ___ and
 * not 3/4 = x/12 has learnt a notation rather than an idea. Mixed puts them on
 * one page.
 *
 * Proportional Tables (ADR 0104) is offered with the rest and is outside
 * Mixed. The dial is then the largest y a table may print.
 */
export function RatioSettings() {
    const { settings, setSettings } = useContext(SettingsContext);
    const t = useTranslation();

    function handleQuestionChange(value: RatioQuestionOptions) {
        // SelectButton hands back null when the selected option is clicked
        // again; a sheet has to ask something.
        if (!value) {
            return;
        }
        setSettings({ ...settings, RatioQuestion: value });
    }

    function handleMaxValueChange(event) {
        setSettings({ ...settings, RatioMaxValue: Number(event.target.value) });
    }

    return (
        <div className="ratioSettingsContainer">
            <div className="regroupingContainer">
                <SelectButton
                    value={settings.RatioQuestion}
                    onChange={(e) => handleQuestionChange(e.value)}
                    options={withLabels(Object.values(RatioQuestionOptions), settings.Language)}
                    className="select regrouping"
                    aria-label={t('settings.questionType')}
                />
            </div>
            <div className="selectContainer">
                <span className="settingLabel">{t('settings.largestNumberLabel')}</span>
            </div>
            <div className="radioButtons" role="radiogroup" aria-label={t('settings.largestNumberAria')}>
                {RATIO_MAX_VALUE_OPTIONS.map((option) => (
                    <div key={option}>
                        <RadioButton
                            inputId={`ratioMaxValue-${option}`}
                            value={option}
                            checked={settings.RatioMaxValue === option}
                            onChange={handleMaxValueChange}
                        />
                        <label htmlFor={`ratioMaxValue-${option}`}>{option}</label>
                    </div>
                ))}
            </div>
        </div>
    );
}

export default RatioSettings;
